import React from "react"; 
import Swal from "sweetalert2";

class App extends React.Component {
    state = {
        rows: this.props.property.length>0 ? this.props.property : [{}]
    };


    handleChange = idx => e => {
        const { name, value } = e.target;
        const rows = [...this.state.rows];
        rows[idx] = {
            [name]: value
        };
        this.setState({
            rows
        });
    };
    handleAddRow = () => {
        const item = {
            type: "",
            propname: "",

        };
        this.setState({
            rows: [...this.state.rows, item]
        });
    };
    handleRemoveRow = () => {
        this.setState({
            rows: this.state.rows.slice(0, -1)
        });
    };
    handleRemoveSpecificRow = (idx) => () => {
        const rows = [...this.state.rows]
        rows.splice(idx, 1)
        this.setState({ rows })
    }

    Savedata = () => {

        if(this.state.rows.length == 0){
            this.props.setProperty("");
            this.props.handleClose();
        }else{
        let arr = Array();
        for (let i = 0; i <= this.state.rows.length - 1; i++) {
            let type = document.getElementById(`type-${i}`).value;
            let propname = document.getElementById(`propname-${i}`).value; 

            if(type!="" && propname!=""){
                arr.push({
                    type: document.getElementById(`type-${i}`).value,
                    propname: document.getElementById(`propname-${i}`).value,
    
                })
                this.props.setProperty(arr)
                this.props.handleClose();
            }else{
                Swal.fire({
                    icon:'error',
                    text:'Please fill the details',
                }) 
                this.props.handleClose();
            }
          
        }
    }
       
    }
    render() {
        return (
            <div>
                <div className="first_modal">
                    <div className="container">
                        <div className="row clearfix">
                            <div className="col-md-12 column">
                                <div>
                                    <table className="table table-bordered table-hover" id="tab_logic" >
                                        <thead>
                                            <tr>
                                                <th className="text-center"> Type </th>
                                                <th className="text-center"> Name </th>
                                                <th />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.rows.map((item, idx) => (
                                                <tr id="addr0" key={idx}>
                                                     
                                                    <td>
                                                        <input type="text" id={`type-${idx}`} value={this.state.rows[idx].type}
                                                            onChange={this.handleChange(idx)} placeholder='Key' className="form-control" />
                                                    </td>
                                                    <td>
                                                        <input type="text" id={`propname-${idx}`}
                                                            value={this.state.rows[idx].propname} onChange={this.handleChange(idx)} className="form-control" />
                                                    </td>
                                                    <td>
                                                        <button className="btn btn-outline-danger btn-sm" onClick={this.handleRemoveSpecificRow(idx)} >
                                                            Remove
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <button onClick={this.handleAddRow} className="btn btn-primary">
                                        Add Row
                                    </button>
                                    <br></br>
                                    <br></br>
                                    <button className="btn_sun" marginY='5px' onClick={this.Savedata}>
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default App;